<template>
	<v-dialog v-model="clienteDialog" :max-width="400" scrollable>
		<v-card>
			<v-progress-linear v-if="loading" indeterminate color="primary"></v-progress-linear>
			<v-card-title>
				<v-icon left>mdi-cog</v-icon>
				DDA
				<v-spacer></v-spacer>
				<v-btn icon @click="dialogClose">
					<v-icon>close</v-icon>
				</v-btn>
			</v-card-title>
			
			<v-card-text>
				<v-col>
					<v-row>
						<v-text-field :disabled="loading" type="number" min="0" step="1" v-model="qtdPagador" @keypress="onlyNumbers" label="Quantidade de Pagadores"/>
					</v-row>
					<v-row>
						<v-spacer />
						<v-btn color="primary" @click="setQtdPagador()" :disabled="loading || !qtdPagador">Salvar </v-btn>
					</v-row>
				</v-col>
			</v-card-text>
		</v-card>
	</v-dialog>
</template>
<script>

import { mapGetters, mapState } from 'vuex'

export default {
	props: {
		cliente: Object,
		dialog: Boolean,
	},
	data: function () {
		return {
			loading: false,
		}
	},
	computed: {
		...mapGetters(['userAdmin', 'userMaster']),
		...mapState(['user']),
		clienteDialog: {
			get() {
				return this.dialog
			},
			set() {
				this.dialogClose()
			},
		},
		qtdPagador:{
			get(){
				return this.cliente.qtpag_dda
			},
			set(value){
				this.cliente.qtpag_dda = value
			}
		}
	},

	methods: {
		dialogClose() {
			this.$emit('dialogClose')
		},
        onlyNumbers(event) {
            if (!/^\d+$/.test(event.key)) {
                  event.preventDefault();
              }
        },
		async setQtdPagador() {
			try {
				this.loading = true
				const response = await this.axios.post(`/clientes/${this.cliente.id}/dda/pagadores`, {
					qtdpagadores: this.qtdPagador,
				})
				this.$store.dispatch('showSuccess', response.data.msg)
				this.dialogClose()
			} catch (error) {
				this.$store.dispatch('showError', error)
			} finally {
				this.loading = false
			}
		},
	},
}
</script>